import React from 'react';
import { 
	number, 
	array,
	func,
	bool, 
} from 'prop-types';
import {InfoTooltip} from '../../molecules/Tooltip';
import '../../../i18n';
import { withNamespaces } from 'react-i18next';
import style from './style';

const Presenter = ({quizCount,tags,onRemoveTag,onAddTag,handleShuffle,shuffle,t,...props})=> {
	return (
		<style.Wrapper {...props}>
			<style.TagsWrapper>
				<style.TagLabel>Tags</style.TagLabel>
				<style.InputChip tags={tags} onRemove={onRemoveTag} onEnter={onAddTag}/>
			</style.TagsWrapper>
			<style.QuizHeader >
				<InfoTooltip text={t('create-quiz.ShuffleQuizHelp')}>
					<style.Shuffle>
					
						<style.Checkbox checked={shuffle} onCheck={handleShuffle}>
							{t('create-quiz.Shuffle')}
						</style.Checkbox>
					</style.Shuffle>
				</InfoTooltip>
				
				<style.Title>Questins({quizCount})</style.Title>
			</style.QuizHeader>
		</style.Wrapper>
	);
};

Presenter.propTypes = {
	quizCount : number,
	tags : array,
	onRemoveTag : func,
	handleShuffle : func.isRequired,
	shuffle : bool,
	onAddTag : func
};

export default withNamespaces()(Presenter);